import createStorageHook from './shared/createStorageHook';
/**
 * Save a value on local storage
 */
const useLocalStorage = createStorageHook('local');
export default useLocalStorage;
